<template>
  <nav class="site-navbar" :class="'site-navbar--' + navbarLayoutType">
    <div class="site-navbar__body clearfix">
      <el-menu class="site-navbar__menu pull-left" mode="horizontal">
        <el-menu-item class="site-navbar__switch" index="0" @click="sidebarFold = !sidebarFold" style="line-height:46px">
          <a class="iconfold"> <i class="el-icon-s-fold" title="收起"></i></a>
        </el-menu-item>
      </el-menu>
      <div class="site-navbar__menu pull-right">
        <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item>
            <el-dropdown>
              <span class="el-dropdown-link">
                {{userdata.ccustomername}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="userConter()">
                  <i class="el-icon-user-solid"></i><span>个人信息</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="updatePasswordHandle()"><i class="el-icon-s-help"></i><span>修改密码</span></el-dropdown-item>
                <el-dropdown-item @click.native="logoutHandle()"><i class="el-icon-switch-button" style="font-weight: bold;"></i><span>注销</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>
          <!-- <el-menu-item><i class="el-icon-s-custom"></i><span>添加账号</span></el-menu-item> -->
          <!-- <el-menu-item @click.native="updatePasswordHandle()"><i class="el-icon-unlock" style="font-weight: bold;"></i><span>修改密码</span></el-menu-item> -->
          <!-- <el-menu-item></el-menu-item> -->
        </el-menu>
        <div class="line"></div>
      </div>

    </div>
    <!-- 弹窗, 修改密码 -->

    <update-password v-if="updatePassowrdVisible" ref="updatePassowrd" :disvisible="updatePassowrdVisible" @fgtpaw="fgtpaw" :userdata="userdata"></update-password>

    <update-info v-if="updateInfoVisible" ref="updateInfo"></update-info>
  </nav>
</template>

<script>
import UpdatePassword from "./main-navbar-update-password";
import UpdateInfo from "./main-navbar-update-info";

export default {
  data() {
    return {
      userdata: {},
      drawer: false,
      updatePassowrdVisible: false,
      updateInfoVisible: false,
      unreadCount: 0,
    };
  },
  components: {
    UpdatePassword,
    UpdateInfo,
  },
  mounted() {},
  created() {
    console.log(JSON.parse(localStorage.getItem("userdata")));
    this.userdata = JSON.parse(localStorage.getItem("userdata"));
  },
  computed: {
    navbarLayoutType: {
      get() {
        return this.$store.state.common.navbarLayoutType;
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
      set(val) {
        this.$store.commit("common/updateSidebarFold", val);
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.common.mainTabs;
      },
      set(val) {
        this.$store.commit("common/updateMainTabs", val);
      },
    },
    userName: {
      get() {
        return this.$store.state.user.name;
      },
    },
    workingSpace: {
      get() {
        return this.$store.state.user.workingSpace;
      },
      set(val) {
        this.$store.commit("user/setWorkingSpace", val);
      },
    },
    nickName: {
      get() {
        return this.$store.state.user.nickName;
      },
      set(val) {
        this.$store.commit("user/setNickName", val);
      },
    },
    workingSpaceShow: {
      get() {
        return this.$store.state.user.workingSpaceShow;
      },
      set(val) {
        this.$store.commit("user/setWorkingSpaceShow", val);
      },
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 修改密码
    fgtpaw(val) {
      this.updatePassowrdVisible = val;
    },
    // 修改密码
    updatePasswordHandle() {
      this.updatePassowrdVisible = true;
      this.$nextTick(() => {
        this.$refs.updatePassowrd.init();
      });
    },
    // 退出
    logoutHandle() {
      this.$confirm(`确定进行[退出]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push({ name: "login" });
          this.$store.state.common.mainTabs = [
            {
              iframeUrl: "",
              menuId: "home",
              name: "home",
              params: "",
              query: "",
              title: "首页",
            },
          ];
          window.location.reload();

          // this.$router.push({name: 'login'})
          // this.$http({
          //   url: this.$http.adornUrl('/sys/logout'),
          //   method: 'post',
          //   data: this.$http.adornData()
          // }).then(({data}) => {
          //   if (data && data.code === 0) {

          //     this.$router.push({name: 'login'})
          //   }
          // })
        })
        .catch(() => {});
    },
    userConter() {
      let { href } = this.$router.resolve({ path: "/UserCenterinfoNot" });
      window.open(href, "_blank");
    },
  },
};
</script>
<style scoped>
.site-navbar__menu .myMenu {
  padding: 0 10px;
}
</style>
